module.exports = __webpack_public_path__ + "img/11_college.35feb17e.png";